import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, Link } from "react-router-dom";
import { logout } from "../../slices/auth";

import * as Svg from "../svg";
import AskellProductTour from "../tour";

export const Topbar = (props) => {

    const dispatch = useDispatch()
    const navigate = useNavigate()
    const { user } = useSelector((state) => state.auth)

    const doLogout = () => {
        Promise.resolve(dispatch(logout()))
            .then(() => {
                window.location.href = '/accounts/login/'
            })
    }
    const styles = {
        top: "0",
        right: "44px",
        height: "1px",
        width: "1px",
        position: "relative",
        marginTop: "0px",
    }

    return (
        <div className="topbar">
            {/* <AskellProductTour /> */}
            <div className="topbar__account me-auto">
                {user?.account_name && <>
                    <Link to={"/settings/account/"}>{user.account_name}</Link>
                </>}
            </div>
            <div className="topbar__user me-5">
                <div id="noticeable-widget" style={styles}></div>
                <div className="d-none d-md-block">{user?.username}</div>
            </div>
            {user?.authenticated &&
                <div className="topbar_logout d-none d-md-flex align-items-center" onClick={() => doLogout()}>{gettext('Logout')}
                    <Svg.SvgLogout />
                </div>
            }
            <div className="menu-btn d-flex d-md-none flex-column" onClick={() => props.collapseHandler()} >
                <span className="d-inline-block"></span>
                <span className="d-inline-block"></span>
            </div>
        </div>
    )

}